import Vue from 'vue'
import Router from 'vue-router'
import routers from './router'
import constRouters from './constRouter'
import index from '../pages/index/index'
import aboutus from '../pages/aboutus/aboutus'
import jjZhuce from '../pages/aboutus/jjZhuce'
import rzLiucheng from '../pages/aboutus/rzLiucheng'
import mtGuantui from '../pages/aboutus/mtGuantui'
import bgHuanjing from '../pages/aboutus/bgHuanjing'
import fwAldetail from '../pages/aboutus/fwAldetail'
import fwAnli from '../pages/aboutus/fwAnli'
import cgRongyu from '../pages/jrService/cgRongyu'
import fzLiucheng from '../pages/jrService/fzLiucheng'
import gcJieshao from '../pages/jrService/gcJieshao'
import qwYoushi from '../pages/jrService/qwYoushi'
import jjRuzhu from '../pages/jjRuzhu/jjRuzhu'
import squaredetail from '../pages/square/squaredetail'
import square from '../pages/square/square'
import searchXmdetail from '../pages/searchXm/searchXmdetail'
import searchXm from '../pages/searchXm/searchXm'
import joinActivitydetail from '../pages/joinActivity/joinActivitydetail'
import joinActivity from '../pages/joinActivity/joinActivity'
import study from '../pages/study/study'
import studydetail from '../pages/study/studydetail'
import cxPingtai from '../pages/qyFuwu/cxPingtai'
import fwAnlis from '../pages/qyFuwu/fwAnlis'
import hdAldetail from '../pages/qyFuwu/hdAldetail'
import fwTixi from '../pages/qyFuwu/fwTixi'
import jrfuCs from '../pages/qyFuwu/jrfuCs'
import policy from '../pages/policy/policy'
import detail from '../pages/policy/detail'
import ctRibao from '../pages/ctRibao/ctRibao'
import search from '../pages/search/search'
import layout from '../layouts/index'
Vue.use(Router) //vue全局使用Router
export default new Router({
	mode: 'history',
	base: '/',
	routes: [{
			path: '/',
			name: 'index',
			component: index,
		},
		{
			path: '/', 
			component: layout,
			children: [
				// 	{
				// 	path: '/index',
				// 	name: 'index',
				// 	component: index,
				// }, 
				{
					path: '/aboutus',
					name: 'aboutus',
					component: aboutus,
				}, {
					path: '/jjZhuce',
					name: 'jjZhuce',
					component: jjZhuce,
				}, {
					path: '/rzLiucheng',
					name: 'rzLiucheng',
					component: rzLiucheng,
				}, {
					path: '/mtGuantui',
					name: 'mtGuantui',
					component: mtGuantui,
				}, {
					path: '/bgHuanjing',
					name: 'bgHuanjing',
					component: bgHuanjing,
				}, {
					path: '/fwAldetail',
					name: 'fwAldetail',
					component: fwAldetail,
				}, {
					path: '/fwAnli',
					name: 'fwAnli',
					component: fwAnli,
				}, {
					path: '/cgRongyu',
					name: 'cgRongyu',
					component: cgRongyu,
				}, {
					path: '/fzLiucheng',
					name: 'fzLiucheng',
					component: fzLiucheng,
				}, {
					path: '/gcJieshao',
					name: 'gcJieshao',
					component: gcJieshao,
				}, {
					path: '/qwYoushi',
					name: 'qwYoushi',
					component: qwYoushi,
				}, {
					path: '/cxPingtai',
					name: 'cxPingtai',
					component: cxPingtai,
				}, {
					path: '/fwAnlis',
					name: 'fwAnlis',
					component: fwAnlis,
				}, {
					path: '/hdAldetail',
					name: 'hdAldetail',
					component: hdAldetail,
				}, {
					path: '/fwTixi',
					name: 'fwTixi',
					component: fwTixi,
				}, {
					path: '/jrfuCs',
					name: 'jrfuCs',
					component: jrfuCs,
				}, {
					path: '/policy',
					name: 'policy',
					component: policy,
				}, {
					path: '/detail',
					name: 'detail',
					component: detail,
				}, {
					path: '/study',
					name: 'study',
					component: study,
				}, {
					path: '/studydetail',
					name: 'studydetail',
					component: studydetail,
				}, {
					path: '/joinActivity',
					name: 'joinActivity',
					component: joinActivity,
				}, {
					path: '/joinActivitydetail',
					name: 'joinActivitydetail',
					component: joinActivitydetail,
				}, {
					path: '/searchXm',
					name: 'searchXm',
					component: searchXm,
				}, {
					path: '/searchXmdetail',
					name: 'searchXmdetail',
					component: searchXmdetail,
				}, {
					path: '/square',
					name: 'square',
					component: square,
				}, {
					path: '/squaredetail',
					name: 'squaredetail',
					component: squaredetail,
				}, {
					path: '/jjRuzhu',
					name: 'jjRuzhu',
					component: jjRuzhu,
				}, {
					path: '/ctRibao',
					name: 'ctRibao',
					component: ctRibao,
				},{
					path: '/search',
					name: 'search',
					component: search,
				},
			],
		}
	],
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})

function exportWhiteListFromRouter(router) {
	let res = []
	for (let item of router)
		res.push(item.path)
	return res
}
let router = new Router({
	mode: 'history',
	base: '/',
	routes: constRouters
})

function save(name, data) {
	localStorage.setItem(name, JSON.stringify(data))
}
router.addRoutes(routers)
// 路由白名单
const whiteList = exportWhiteListFromRouter(constRouters)
export function resetRouter() {
	location.reload()
}



// WEBPACK FOOTER //
// ./src/router/index.js